import { AnimationSystemEvent } from './AnimationSystem';
import AnimationClip, { AnimationClipEvent } from './AnimationClip';
import * as Animations from './Clip';
import GameObject from '../../GameObject/GameObject';

export function GetAnimationClip(
    clipName: string,
    gameObject: GameObject,
    meta?: any
): AnimationClip {
    if (!(<any>Animations)[clipName])
        throw new Error(`Animation clip '${clipName}' not found.`);

    const animationClip: AnimationClip = new (<any>Animations)[clipName](
        gameObject,
        meta
    );

    return animationClip;
}

export function* PlayAnimation(clip: AnimationClip): IterableIterator<number> {
    if (!clip.gameObject) throw new Error(`GameObject is undefined.`);

    let isPlaying = true;

    clip.on(AnimationClipEvent.COMPLETE, () => {
        isPlaying = false;
    });

    clip.gameObject.scene.emit(AnimationSystemEvent.PLAY, clip);

    while (isPlaying) yield;
}

export function StartAnimationAsync(
    gameObject: GameObject,
    clipName: string,
    meta?: any
) {
    const animationClip = GetAnimationClip(clipName, gameObject, meta);

    return new Promise(resolve => {
        animationClip.once(AnimationClipEvent.COMPLETE, resolve);
        gameObject.scene.emit(AnimationSystemEvent.PLAY, animationClip);
    });
}

export function StartAnimation(
    gameObject: GameObject,
    clipName: string,
    meta?: any
): AnimationClip {
    const animationClip = GetAnimationClip(clipName, gameObject, meta);
    gameObject.scene.emit(AnimationSystemEvent.PLAY, animationClip);

    return animationClip;
}

export function StopAnimation(gameObject: GameObject) {
    gameObject.scene.emit(AnimationSystemEvent.STOP, gameObject);
}

export function StartAnimationClip(clip: AnimationClip): void {
    clip.gameObject.scene.emit(AnimationSystemEvent.PLAY, clip);
}

export function* AwaitIterators(
    iterators: IterableIterator<number>[]
): IterableIterator<number> {
    while (iterators.length > 0) {
        let d = yield;
        const newIterators = [];
        for (let iterator of iterators) {
            if (!iterator.next(d).done) newIterators.push(iterator);
        }
        iterators = newIterators;
    }
}

export function* ConcatIterators(
    iterators: IterableIterator<number>[]
): IterableIterator<number> {
    for (let iterator of iterators) {
        yield* iterator;
    }
}
